<micro-select-combo #sel
              placeholder="Allow Block Type"
              valueField="id"
              [mode]="mode"
              [(id)]="blockAllowType"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
